import * as React from "react";
import PropTypes from "prop-types";
import { useHistory, useLocation } from "react-router-dom";
import Box from "@mui/material/Box";
import CardHeader from "@mui/material/CardHeader";
import Avatar from "@mui/material/Avatar";
import IconButton from "@mui/material/IconButton";
import Tooltip from "@mui/material/Tooltip";
import * as CONST from "../../Constants";
import CprActions from "./CprActions";
import ExtensionsTooltip from "./ExtensionsTooltip";

const propTypes = {
  window: PropTypes.func,
  cpr: PropTypes.object.isRequired,
  spacing: PropTypes.bool,
  children: PropTypes.object,
  reward: PropTypes.object,
  promptHandler: PropTypes.func.isRequired,
  hideActions: PropTypes.bool.isRequired,
  hideAvatar: PropTypes.bool.isRequired,
  variants: PropTypes.object.isRequired,
};

CprCardHeader.prototype = propTypes;

export default function CprCardHeader(props) {
  const history = useHistory();
  const location = useLocation();

  React.useEffect(() => {}, [props.cpr]);
  return (
    <>
      <Box
        sx={{
          padding: props.spacing ? 2 : 0,
          borderRadius: 0.5,
          borderTopLeftRadius: 1,
          borderTopRightRadius: 1,
          bgcolor: !props.hideAvatar ? props.media.bg : "#ffff",
        }}
      >
        <CardHeader
          className="cpr"
          avatar={
            !props.hideAvatar && (
              <Avatar
                sx={{
                  bgcolor: "#ffff",
                  color: props.media.bg,
                }}
                aria-label="cpr status"
              >
                {props.cpr.needs_attention ? (
                  <Tooltip
                    title={
                      props.cpr.needs_attention && (
                        <>
                          {!location.pathname.includes("notifications") ? (
                            <>
                              <b>{CONST.TOOLTIP.CPR_CARD_HEADER.NOTIFCATION_BODY_1}</b>
                            </>
                          ) : (
                            <b>{CONST.TOOLTIP.CPR_CARD_HEADER.ALT}</b>
                          )}
                        </>
                      )
                    }
                  >
                    <IconButton
                      className="notification"
                      sx={{ bgcolor: props.variants.bg }}
                      onClick={(e) => {
                        e.preventDefault();
                        if (!location.pathname.includes("notifications")) {
                          history.push(`/patient_portal/notifications/${props.cpr.id}`);
                        }
                      }}
                    >
                      {props.variants.icon}
                    </IconButton>
                  </Tooltip>
                ) : (
                  props.media.icon
                )}
              </Avatar>
            )
          }
          title={
            <Box sx={{ color: !props.hideAvatar && "#ffff" }}>
              { (props.cpr.cpr_code == "203C - Required Lab Draw") && 'Lab Test:' } {props.cpr.procedure_type}{" "}
              {!!props.cpr.extensions.length > 0 && (
                <ExtensionsTooltip
                  extensions={props.cpr.extensions}
                  originalDueDate={props.cpr.originalDueDate}
                />
              )}
            </Box>
          }
          subheader={
            <Box
              sx={{
                color: !props.hideAvatar ? "#ffff" : "#014361",
              }}
            >
              {props.cpr.completed_on_date ? "Completed: " : props.cpr.date_type + ": "}
              {props.cpr.date}
              {props.cpr.appointment_time &&
                ", " +
                  new Date(props.cpr.appointment_time).toLocaleString("en-US", {
                    hour: "2-digit",
                    minute: "2-digit",
                    timeZone: "America/Los_Angeles",
                    timeZoneName: "short"
                  })
              }
              {props.cpr.completed_on_date ? (
                <>
                  {props.cpr.attending_provider && (
                    <>
                      {", Attending Provider: "} {props.cpr.attending_provider}
                    </>
                  )}
                </>
              ) : (
                <>
                  {", Provider: "}
                  {props.cpr.servicing_provider ? props.cpr.servicing_provider : "TBD"}
                </>
              )}
            </Box>
          }
        />
      </Box>
      {!props.hideActions && (
        <CprActions cpr={props.cpr} promptHandler={props.promptHandler} reward={props.reward} />
      )}
    </>
  );
}
